// extracted by mini-css-extract-plugin
export var b_r_donate = "main-module--b_r_donate--36j15";
export var b_r_donate_wider = "main-module--b_r_donate_wider--c6TOF";
export var b_r_high = "main-module--b_r_high--Mhkh6";
export var b_r_low = "main-module--b_r_low--b7S1V";
export var b_r_mid = "main-module--b_r_mid--zH616";
export var b_r_reset = "main-module--b_r_reset--E9hsT";
export var boldinfo = "main-module--boldinfo--VcTzS";
export var buttonContainer = "main-module--buttonContainer--f2fk0";
export var buttonconfirmtext = "main-module--buttonconfirmtext--At2rP";
export var controlbutton = "main-module--controlbutton--0bUqv";
export var donationCard = "main-module--donationCard--c4sHR";
export var resetButtonContainer = "main-module--resetButtonContainer--PMzcX";
export var submitButtonContainer = "main-module--submitButtonContainer--mzBNz";
export var sumContainer = "main-module--sumContainer--rlQJn";